module.exports = __webpack_public_path__ + "media/images/icons/material/briefcase-519e966aa465aad4c0655f0ebcc96ba1.svg";